import { Fetch } from 'lib';
import type { ShippingConfig } from 'types';

type RequestResponses = ShippingConfig;

type RequestParameters = {
  id: string;
};

const getShippingConfig = async (params: RequestParameters) =>
  await Fetch<RequestResponses, RequestParameters>({
    url: 'adminShippingConfig/getShippingConfig',
    params,
  });

export { getShippingConfig };
